module.exports = __webpack_public_path__ + "img/g11.683279cb.jpg";